import { render, staticRenderFns } from "./WorkingHoursList.vue?vue&type=template&id=8ff44570"
import script from "./WorkingHoursList.vue?vue&type=script&lang=js"
export * from "./WorkingHoursList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports